// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { ButtonVariants } from "@insite/mobius/Button/Button";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

export type ButtonVariantOption = DataOption;
export interface ButtonVariantOptionMapper {
    primary: ButtonVariantOption;
    secondary: ButtonVariantOption;
    tertiary: ButtonVariantOption;
    inverted: ButtonVariantOption;
    // bunzl custom codeui
    primaryDark: ButtonVariantOption;
}
export type ButtonVariantOptions = DataOptions<ButtonVariantOption> & ButtonVariantOptionMapper;
export type ButtonVariant = LiteralUnion<keyof ButtonVariantOptionMapper>;

export const buttonVariantOptions: ButtonVariantOptions = {
    primary: { id: "primary", displayName: "Primary", isDefault: true },
    secondary: { id: "secondary", displayName: "Secondary" },
    tertiary: { id: "tertiary", displayName: "Tertiary" },
    inverted: { id: "inverted", displayName: "Inverted" },
    // bunzl custom code
    primaryDark: { id: "primaryDark", displayName: "Primary Dark" },
};

export type ButtonVariantFieldValue = ButtonVariant | undefined;
export interface ButtonVariantFieldOptions {
    isChildDefinition?: boolean;
}

export const getButtonVariantFieldData = (value: ButtonVariantFieldValue, options?: ButtonVariantFieldOptions) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(buttonVariantOptions, value) as ButtonVariants;
};

export const getButtonVariantFieldDefinition = (name: string, options?: ButtonVariantFieldOptions) => {
    const { isChildDefinition } = options || {};

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(buttonVariantOptions),
        name,
        displayName: "Button Variant",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getButtonVariantField = (name: string, options?: ButtonVariantFieldOptions) => {
    const parse = (value: ButtonVariantFieldValue) => getButtonVariantFieldData(value, options);

    return {
        definition: getButtonVariantFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
    };
};

export default getButtonVariantField;
